// Zentrale Konfiguration – Kontaktdaten hier pflegen.
export const SITE = {
  name: "Hanse Garten Bremen",
  owner: "Salih Koluman",
  legalForm: "Einzelunternehmen",
  street: "Große Weidestraße 2",
  zipCity: "28195 Bremen",
  country: "Deutschland",
  // Nur WhatsApp liegt vor. Telefon/E-Mail bewusst leer – später eintragen.
  whatsappNumber: "+49 176 84683034",
  whatsappRaw: "4917684683034",
  phone: "",
  email: "Info@hansegarten-bremen.de",
};

export const WHATSAPP_MESSAGE =
  "Hallo Hanse Garten Bremen, ich möchte gerne mein Gartenprojekt besprechen.";

export const waLink = (message = WHATSAPP_MESSAGE) =>
  `https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent(message)}`;

// Eigene Projektfotos des Unternehmens
export const IMG = {
  logo:
    "https://customer-assets-agu9un31.emergentagent.net/job_fa5c5de4-d9e0-47cc-bd56-936213c94281/artifacts/0c077eb7_ChatGPT%20Image%2020.%20Sept.%202026%2C%2011_45_55.png",
  formal:
    "https://customer-assets-agu9un31.emergentagent.net/job_fa5c5de4-d9e0-47cc-bd56-936213c94281/artifacts/18cqkc5b_unnamed%20%2829%29.webp",
  terrasse:
    "https://customer-assets-agu9un31.emergentagent.net/job_fa5c5de4-d9e0-47cc-bd56-936213c94281/artifacts/nm8n8ol3_unnamed%20%2831%29.webp",
  rasen:
    "https://customer-assets-agu9un31.emergentagent.net/job_fa5c5de4-d9e0-47cc-bd56-936213c94281/artifacts/jglh1k68_unnamed%20%2832%29.webp",
  umbau:
    "https://customer-assets-agu9un31.emergentagent.net/job_fa5c5de4-d9e0-47cc-bd56-936213c94281/artifacts/r4w6ixci_unnamed%20%2827%29.webp",
};

// Atmosphäre- und Materialbilder
export const ATMO = {
  hero: "https://images.unsplash.com/photo-1780519123579-2088d9560826?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=2400",
  gruen: "https://images.pexels.com/photos/39173654/pexels-photo-39173654.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  stein: "https://images.pexels.com/photos/39009170/pexels-photo-39009170.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  holz: "https://images.unsplash.com/photo-1734079692147-c6fc9438a2d0?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600",
  licht: "https://images.pexels.com/photos/35135105/pexels-photo-35135105.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  editorial: "https://images.unsplash.com/photo-1776186243408-3c0489503faa?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600",
  terrassiert: "https://images.pexels.com/photos/37985161/pexels-photo-37985161.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
};

export const NAV = [
  { label: "GARTEN", to: "/" },
  { label: "LEISTUNGEN", to: "/leistungen" },
  { label: "PROJEKTE", to: "/projekte" },
  { label: "ÜBER UNS", to: "/ueber-uns" },
  { label: "KONTAKT", to: "/kontakt" },
];
